import { getBaseUrl, Microservice } from "../constant/baseUrl";
import { getApiResponseErrorMsg } from "../Utils/apiHelper";
import axios from "axios";

export interface DownloadSkuPoCsvRequest {
  orgRoleId: number;
  token: string;
}

const downloadSkuPoCsv = async ({
  orgRoleId,
  token,
}: DownloadSkuPoCsvRequest) => {
  try {
    const response = await axios.post(
      `${getBaseUrl(Microservice.SKU_FINANCE)}/sku-finance/loan-application/download-sku-po-ocr-csv/${orgRoleId}`,
      {},
      {
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
        responseType: "blob",
        withCredentials: true,
      },
    );

    return response.data;
  } catch (e) {
    const message = getApiResponseErrorMsg(e);

    throw new Error(message);
  }
};

export default downloadSkuPoCsv;
